module.exports = __webpack_public_path__ + "static/media/pentagram.ebfed2bc.png";